
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
/**
- Pass the card <b>elevation</b> prop to set the card's elevation type
- To modify the image container maxheight/width; modify <b>.eu-imagecontainer</b>
- To make the info card with inner spacing, use prop <b>cardspacing</b>
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralInfoCard',
  components: {
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set image
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set subtitle
     */
    subtitle: {
      type: String,
      default: ''
    },
    /**
     * Use custom content
     */
    customContent: {
      type: Boolean,
      default: false
    },
    /**
     * Set info card to smaller size
     */
    smaller: {
      type: Boolean,
      default: false
    },
    /**
     * Set info card with some spacing
     */
    cardspacing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedBackground() {
      return `background-image: url(${this.image})`;
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Method to click card
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleClickImage(e: any) {
      /**
       * Method to click image
       * @event upload
       * @type {function}
       */
      this.$emit('upload', e);
    }
  }
});
